/* ==========================================================================
   NOXA — JavaScript du thème (vanilla, sans dépendance)
   Accordéons · Carrousel à onglets · Avant/Après · Marquee · Panier
   ========================================================================== */
(function () {
  'use strict';

  /* --------------------------- Accordéons -------------------------------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('[data-acc]').forEach(function (acc) {
      if (acc.dataset.accInit) return;
      acc.dataset.accInit = '1';
      acc.querySelectorAll('.noxa-acc__head, .noxa-faq__head').forEach(function (head) {
        head.addEventListener('click', function () {
          var item = head.closest('.noxa-acc__item, .noxa-faq__item');
          if (!item) return;
          var isOpen = item.classList.contains('is-open');
          if (!acc.hasAttribute('data-acc-multi')) {
            acc.querySelectorAll('.is-open').forEach(function (el) { el.classList.remove('is-open'); });
          }
          item.classList.toggle('is-open', !isOpen);
        });
      });
    });
  }

  /* ------------------------- Carrousel onglets --------------------------- */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(function (car) {
      if (car.dataset.carInit) return;
      car.dataset.carInit = '1';

      var tabs = car.querySelectorAll('[data-carousel-tab]');
      var panels = car.querySelectorAll('[data-carousel-panel]');

      function activatePanel(panel) {
        var track = panel.querySelector('[data-carousel-track]');
        var slides = panel.querySelectorAll('[data-carousel-slide]');
        var dotsWrap = panel.querySelector('[data-carousel-dots]');
        var idx = 0;

        function render() {
          if (track) track.style.transform = 'translateX(' + (-idx * 100) + '%)';
          if (dotsWrap) {
            dotsWrap.querySelectorAll('button').forEach(function (d, i) {
              d.classList.toggle('is-active', i === idx);
            });
          }
        }
        function go(d) { idx = (idx + d + slides.length) % slides.length; render(); }

        var prev = panel.querySelector('[data-carousel-prev]');
        var next = panel.querySelector('[data-carousel-next]');
        if (prev && !prev.dataset.b) { prev.dataset.b = 1; prev.addEventListener('click', function () { go(-1); }); }
        if (next && !next.dataset.b) { next.dataset.b = 1; next.addEventListener('click', function () { go(1); }); }

        if (dotsWrap && !dotsWrap.dataset.built) {
          dotsWrap.dataset.built = 1;
          dotsWrap.innerHTML = '';
          slides.forEach(function (_, i) {
            var b = document.createElement('button');
            b.className = 'noxa-carousel__dot' + (i === 0 ? ' is-active' : '');
            b.type = 'button';
            b.setAttribute('aria-label', 'Slide ' + (i + 1));
            b.addEventListener('click', function () { idx = i; render(); });
            dotsWrap.appendChild(b);
          });
        }
        render();
      }

      // initialiser chaque panneau
      panels.forEach(activatePanel);

      // onglets
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-carousel-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) {
            p.style.display = (p.getAttribute('data-carousel-panel') === target) ? '' : 'none';
          });
        });
      });
      panels.forEach(function (p, i) { p.style.display = i === 0 ? '' : 'none'; });
      if (tabs[0]) tabs[0].classList.add('is-active');
    });
  }

  /* --------------------------- Avant / Après ----------------------------- */
  function initBeforeAfter(root) {
    (root || document).querySelectorAll('[data-ba]').forEach(function (ba) {
      if (ba.dataset.baInit) return;
      ba.dataset.baInit = '1';

      var after = ba.querySelector('.noxa-ba__after');
      var divider = ba.querySelector('.noxa-ba__divider');
      var dragging = false;

      function setPos(clientX) {
        var r = ba.getBoundingClientRect();
        var p = ((clientX - r.left) / r.width) * 100;
        p = Math.max(0, Math.min(100, p));
        if (after) after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
        if (divider) divider.style.left = p + '%';
      }
      setPos(ba.getBoundingClientRect().left + ba.offsetWidth / 2);

      ba.addEventListener('mousedown', function (e) { dragging = true; setPos(e.clientX); });
      ba.addEventListener('touchstart', function (e) { dragging = true; setPos(e.touches[0].clientX); }, { passive: true });
      window.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
      window.addEventListener('touchmove', function (e) { if (dragging && e.touches[0]) setPos(e.touches[0].clientX); }, { passive: true });
      window.addEventListener('mouseup', function () { dragging = false; });
      window.addEventListener('touchend', function () { dragging = false; });
    });
  }

  /* ------------------------------ Marquee -------------------------------- */
  function initMarquees(root) {
    (root || document).querySelectorAll('[data-marquee]').forEach(function (m) {
      if (m.dataset.mInit) return;
      m.dataset.mInit = '1';
      var track = m.querySelector('.noxa-marquee__track, .ann-track');
      var speed = m.getAttribute('data-marquee') || '28';
      if (track) track.style.animationDuration = speed + 's';
    });
  }

  /* ------------------------------- Panier -------------------------------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function renderCart(cart) {
    var content = document.getElementById('NoxaCartContent');
    var countEls = document.querySelectorAll('[data-cart-count]');
    if (!cart) return;
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (!content) return;
    if (cart.item_count === 0) {
      content.innerHTML = '<p class="noxa-cart-drawer__empty">' + (content.dataset.empty || 'Dein Warenkorb ist leer.') + '</p>';
      return;
    }
    var html = '';
    cart.items.forEach(function (it) {
      html += '<div style="display:flex;gap:12px;padding:14px 0;border-bottom:1px solid #eee;">' +
        (it.image ? '<img src="' + it.image + '" width="60" height="60" style="border-radius:8px;object-fit:cover;">' : '') +
        '<div style="flex:1"><div style="font-weight:700;font-size:14px">' + it.product_title + '</div>' +
        '<div style="color:#888;font-size:13px">' + it.quantity + ' × ' + (it.price / 100).toFixed(2) + ' €</div></div></div>';
    });
    html += '<div style="margin-top:18px;display:flex;justify-content:space-between;font-weight:700"><span>Summe</span><span>' +
      (cart.total_price / 100).toFixed(2) + ' €</span></div>' +
      '<a href="/checkout" class="noxa-btn noxa-btn--dark" style="width:100%;margin-top:18px;">Zur Kasse</a>';
    content.innerHTML = html;
  }

  function openCart() {
    var d = document.getElementById('NoxaCartDrawer');
    if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); }
    fetchCart().then(renderCart);
  }
  function closeCart() {
    var d = document.getElementById('NoxaCartDrawer');
    if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-cart-open]');
      if (open) { e.preventDefault(); openCart(); }
      var close = e.target.closest('[data-cart-close]');
      if (close) { e.preventDefault(); closeCart(); }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('disabled', 'disabled');
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) { renderCart(cart); openCart(); })
        .catch(function () {})
        .finally(function () { if (btn) btn.removeAttribute('disabled'); });
    });

    fetchCart().then(renderCart);
  }

  /* ----------------------- Sélecteur de variantes ------------------------ */
  function initVariantPickers(root) {
    (root || document).querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      if (picker.dataset.vpInit) return;
      picker.dataset.vpInit = '1';
      var dataEl = picker.querySelector('[data-variant-json]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent || '[]');
      var swatches = picker.querySelectorAll('[data-variant-swatch]');
      var idInput = picker.querySelector('[name="id"]');
      var label = picker.querySelector('[data-variant-label]');

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          var vid = sw.getAttribute('data-variant-id');
          if (idInput) idInput.value = vid;
          if (label) label.textContent = sw.getAttribute('data-variant-title') || '';
        });
      });
    });
  }

  /* ---------------------------- Galerie PDP ------------------------------ */
  function initGalleries(root) {
    (root || document).querySelectorAll('[data-gallery]').forEach(function (g) {
      if (g.dataset.gInit) return;
      g.dataset.gInit = '1';
      var main = g.querySelector('[data-gallery-main]');
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var src = thumb.getAttribute('data-full');
          if (main && src) main.style.backgroundImage = 'url(' + src + ')';
        });
      });
    });
  }

  /* --------------------------- Voir plus / moins ------------------------- -- */
  function initShowMore(root) {
    (root || document).querySelectorAll('[data-show-more]').forEach(function (wrap) {
      if (wrap.dataset.smInit) return;
      wrap.dataset.smInit = '1';
      var grid = wrap.querySelector('[data-sm-grid]');
      var btn = wrap.querySelector('[data-sm-btn]');
      var count = wrap.querySelector('[data-sm-count]');
      if (!grid || !btn) return;
      var total = parseInt(wrap.getAttribute('data-total'), 10) || 0;
      var initial = parseInt(wrap.getAttribute('data-initial'), 10) || 0;
      var word = wrap.getAttribute('data-word') || '';
      var moreText = btn.getAttribute('data-more');
      var lessText = btn.getAttribute('data-less');
      btn.addEventListener('click', function () {
        var expanded = grid.classList.toggle('expanded');
        btn.textContent = expanded ? lessText : moreText;
        if (count) count.textContent = (expanded ? total : initial) + ' von ' + total + ' ' + word;
      });
    });
  }

  /* ------------------------------- Init ---------------------------------- */
  function initAll(root) {
    initAccordions(root);
    initCarousels(root);
    initBeforeAfter(root);
    initMarquees(root);
    initVariantPickers(root);
    initGalleries(root);
    initShowMore(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initCart();
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
